import { Scope } from '../services/scope';
import { internalLogger } from '../interface/v1/clientOsLogger';
import { DAOItemType, IShellDAO } from './IShellDAO';
import { FindAllRepositoryItemsParams } from './types';

class ShellSessionStorageDAOImpl implements IShellDAO {
  delete(key: string): boolean {
    const obj = this.findOne(key);
    if (obj) {
      sessionStorage.removeItem(key);
      return true;
    }
    return false;
  }

  findOne(key: string): Scope[] {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (err) {
      internalLogger?.error(err);
      return undefined;
    }
  }

  save(key: string, value: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  saveAll(key: string, values: []): void {
    this.save(key, values);
  }

  removeItem(key: string) {
    try {
      return sessionStorage.removeItem(key);
    } catch (err) {
      internalLogger?.error(err);
      return undefined;
    }
  }

  deleteAll(keys: string[]): void {
    try {
      keys.forEach((key) => sessionStorage.removeItem(key));
    } catch (err) {
      internalLogger?.error(err);
      return undefined;
    }
  }

  findAll({ prefixKey }: FindAllRepositoryItemsParams): DAOItemType[] {
    const items = [] as DAOItemType[];
    // TODO: i'm not sure if the code below Skip built-in properties
    // like length, setItem, etc.
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key.startsWith(prefixKey)) {
        items.push({ key, value: this.findOne(key) });
      }
    }
    return items;
  }
}

export default ShellSessionStorageDAOImpl;
